import React from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

const DefaultCoverageOptOutsList = ({
  onSelectDefaultCoverageOptOut,
  defaultCoverageOptOuts = [],
}) => {
  const listRow = ListRow(onSelectDefaultCoverageOptOut);

  // Ordered soonest-to-expire first, never-expiring last — APMS's findAll ORDER
  // BY (end_date IS NULL), end_date, id; not re-sorted here.
  const headerRow = (
    <Table.Row>
      <Table.HeaderCell>Buyer Number</Table.HeaderCell>
      <Table.HeaderCell>Auction Access Number</Table.HeaderCell>
      <Table.HeaderCell>Seller Number</Table.HeaderCell>
      <Table.HeaderCell>Product</Table.HeaderCell>
      <Table.HeaderCell>Start Date</Table.HeaderCell>
      <Table.HeaderCell>End Date</Table.HeaderCell>
      <Table.HeaderCell>Notes</Table.HeaderCell>
      <Table.HeaderCell>Status</Table.HeaderCell>
      <Table.HeaderCell>Created By</Table.HeaderCell>
      <Table.HeaderCell>Created At</Table.HeaderCell>
      <Table.HeaderCell>Updated By</Table.HeaderCell>
      <Table.HeaderCell />
    </Table.Row>
  );

  return (
    <div>
      <Header data-testid='default-coverage-opt-out-heading'>
        Default Coverage Opt-Outs
      </Header>
      <div>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={defaultCoverageOptOuts}
          headerRow={headerRow}
          size='tiny'
          compact='very'
          style={{ fontSize: '90%' }}
          striped
        />
      </div>
    </div>
  );
};

DefaultCoverageOptOutsList.propTypes = {
  onSelectDefaultCoverageOptOut: PropTypes.func.isRequired,
  defaultCoverageOptOuts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      buyerNumber: PropTypes.string,
      sellerNumber: PropTypes.string,
      auctionAccessNumber: PropTypes.string,
      productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      productCode: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      notes: PropTypes.string,
      status: PropTypes.string,
      version: PropTypes.number,
      createdBy: PropTypes.string,
      createdAt: PropTypes.string,
      updatedBy: PropTypes.string,
      updatedAt: PropTypes.string,
    })
  ),
};

export default DefaultCoverageOptOutsList;
